import React from "react";
import Skeleton from "react-loading-skeleton";

const DataSkeleton = (props:any) => {
  const {dashboard, arrayLength=5}=props
  function SkeletonStatBox() {
    return (
      <div className={!dashboard ? "m-0" : "m-0px"} 
      >
        <Skeleton
        className="skeleton"
        width={arrayLength === 8 ? "100%" : ""}
        />
      </div>
    );
  }

  return (
    <div>
      <div
        className="mainDiv"
      >
        <div
          className="data-skeleton"
          style={{
            width: arrayLength === 8 ? "100%" : "",
            display: arrayLength === 8 ? "grid" : "",
            gridTemplateColumns: arrayLength === 8 ? "repeat(auto-fit, minmax(143px, 1fr))" : "",
            gap: arrayLength === 8 ? "1rem" : ""
          }}
        >
          {[...Array(arrayLength)].map((_, index) => (
            <SkeletonStatBox key={index}
            />
          ))}
          </div>
      </div>
    </div>
  );
};

export default DataSkeleton;
